import React, { useEffect, useReducer } from "react";
import Loading from "../../Loading";
import { lockedReducer } from "../../../utils/defaultReducer";
import api from "../../../api";
import { getSession } from "../../../auth";
import useNotification from "../../Notification";

const delete_calendar = async (calendar) => {
    const enterpriseId = getSession()?.profile?.enterprise?.id
    const res = await api.delete(`/api/enterprises/${enterpriseId}/calendars/${calendar.id}/`)
    if (res.status === 204){
        show_calendar(calendar)
        useNotification('Successo!', 'Calendário excluído com sucesso!', 'success')
        return true
    } else {
        useNotification('Ops!', 'Calendário não excluído', 'danger')
        return false
    }
        
}

const toggle_calendar = (row) => {
    const calendar = distributedCalendar.data.find(calendar => calendar.id === row.id)
    if (calendar){
      calendar.hide = !calendar.hide
      !calendar.hide ?  show_calendar(calendar) : hide_calendar(calendar)   
      return {...calendar}
    }
}

const hide_calendar = (calendar) => {
    const hiddenCalendars = new Set(JSON.parse(localStorage.getItem('hiddenCalendars') || '[]'))
    hiddenCalendars.add(calendar.id)
    localStorage.setItem('hiddenCalendars', JSON.stringify(Array.from(hiddenCalendars)))
}

const show_calendar = (calendar) => {
    const hiddenCalendars = new Set(JSON.parse(localStorage.getItem('hiddenCalendars') || '[]'))
    hiddenCalendars.delete(calendar.id)
    localStorage.setItem('hiddenCalendars', JSON.stringify(Array.from(hiddenCalendars)))
}

let distributedCalendarPromise = null;

const get_distributed_calendar = async () => {
  distributedCalendarPromise=null
  const enterpriseId = getSession()?.profile?.enterprise?.id;
  const res = await api.get(`/api/enterprises/${enterpriseId}/calendars/`);

  if (res.status === 200) {
    const hiddenCalendars = new Set(
      JSON.parse(localStorage.getItem('hiddenCalendars') || '[]')
    );
    const data = res.data.map(calendar => ({
      ...calendar,
      hide: hiddenCalendars.has(calendar.id),
    }))
      distributedCalendar.data = data;
      distributedCalendar.data_dict = Object.fromEntries(data.map(d => ([`${d.email}_${d.provider}`, d])))
    return data;
  }

  useNotification('Ops!', 'Agendas não carregadas', 'danger');
  return [];
};

const lazy_data = () => {
  if (!distributedCalendarPromise) {
    distributedCalendarPromise = get_distributed_calendar().then(data => {
      distributedCalendar.data = data;
      distributedCalendar.data_dict = Object.fromEntries(data.map(d => ([`${d.email}_${d.provider}`, d])))
      return distributedCalendar.data;
    });
  }
  return distributedCalendarPromise;
};

const reload_promise = () => {
  distributedCalendarPromise = null
}

const calendar_ownership = (event) => {
  return String(distributedCalendar.data_dict[`${event.email}_${event.calendar}`]?.owner) === String(getSession()?.id)
}

export const distributedCalendar = {
    get_distributed_calendar : get_distributed_calendar,   // function to get all calendars
    data                     : [],                         // property that has calendar data + viewdata
    lazy_data                : lazy_data,                  // function to get the data dynamically after awaiting
    data_dict                : {},                         // property to get data as dict (need data to be fetched)
    toggle_calendar          : toggle_calendar,            // function to toggle calendar
    show_calendar            : show_calendar,              // function to show calendar
    hide_calendar            : hide_calendar,              // function to hide calendar
    delete_calendar          : delete_calendar,            // remove calendar
    reload_calendar          : async () => {},             // reload calendar, must be fed externally
    calendar_ownership       : calendar_ownership,         // check if you own the calendar
    clear_promise            : reload_promise,
} 

const DistributedCalendar = () => {

    const [state, setState] = useReducer(lockedReducer, {
        loading: false
    })

    return (
        <>
            <Loading loading={state.loading} />
        </>
    )
}

export default DistributedCalendar